define.alias("shared/components/shared/credentials/password-input", "media/components/shared/credentials/password-input");